
import { GlobalController } from 'src/shared/global/GlobalController'
import OrganizationalStructure from './OrganizationalStructure'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'organizationalStructure',
    component: OrganizationalStructure,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
